import { Component, Input, TemplateRef } from "@angular/core";
import { NgTemplateOutlet } from "@angular/common";
import { MatExpansionModule } from "@angular/material/expansion";

@Component({
    selector: "eff-expansion-panel",
    templateUrl: "./eff-expansion-panel.component.html",
    styleUrls: ["./eff-expansion-panel.component.scss"],
    imports: [MatExpansionModule, NgTemplateOutlet]
})
export class EffExpansionPanelComponent {
    @Input() title: string;
    @Input() contentTemplate: TemplateRef<any>;
    @Input() panelOpenState: boolean = false;
    @Input() data: any;
    constructor() {}
}
